import { Divider, Drawer, Grid, Typography } from '@material-ui/core';
import { funcaoParticipanteDescriptions } from 'common/genericDescriptions';
import { ParticipanteAuthResponse } from 'common/genericTypes';
import { Button, SmSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootState } from 'store';
import { login } from 'store/modules/auth';
import { FuncaoCard } from './funcaoCard';
import _ from 'lodash';

interface TrocarFuncaoDrawerProps {
  opened: boolean;
  onClose: () => void;
}

const mapDispatchToProps = { login };

type Props = typeof mapDispatchToProps & TrocarFuncaoDrawerProps;

const TrocarFuncaoDrawer: React.FC<Props> = (props) => {
  const { login } = props;
  const usuarioApi = useSelector((state: RootState) => state.usuarioApi);

  const dispatch = useDispatch();
  const history = useHistory();

  const [funcoes, setFuncoes] = useState<ParticipanteAuthResponse[]>([]);
  const [selectedFuncao, setSelectedFuncao] = useState<ParticipanteAuthResponse>();

  const handleTrocarFuncao = () => {
    if (selectedFuncao) {
      usuarioApi
        .login(dispatch, selectedFuncao?.participanteFuncaoUsuarioId)
        .then((result) => {
          login({
            usuario: { ...result, participanteFuncaoUsuarioId: selectedFuncao?.participanteFuncaoUsuarioId },
            token: result.token,
          });
          setSelectedFuncao(undefined);
          props.onClose();
          history.go(0);
        })
        .catch(() => {});
    }
  };

  const getFuncoes = useCallback(async () => {
    try {
      const result = await usuarioApi.getFuncoes(dispatch, true);
      setFuncoes(result);
    } catch { }
  }, []);

  useEffect(() => {
    getFuncoes();
  }, []);

  return (
    <Drawer
      anchor="right"
      open={props.opened}
      onClose={props.onClose}
      PaperProps={{ style: { padding: '40px', width: 438 } }}
    >
      <Grid container>
        <Grid item md={12}>
          <Typography variant="h3">{'Trocar função'}</Typography>
          <SmSpace />
          <Divider variant="fullWidth" />
          <SmSpace />
          {_.orderBy(funcoes, [(funcao) => funcao.razaoSocial, (funcao) => funcao.funcao]).map((funcao) => (
            <React.Fragment key={funcao.participanteFuncaoUsuarioId}>
              <FuncaoCard
                selected={selectedFuncao?.participanteFuncaoUsuarioId === funcao.participanteFuncaoUsuarioId}
                onClick={() => setSelectedFuncao(funcao)}
                title={funcaoParticipanteDescriptions[funcao.funcao]}
                description={funcao.razaoSocial}
              />
              <SmSpace />
            </React.Fragment>
          ))}
          <Button disabled={!selectedFuncao} variant="contained" color="primary" fullWidth onClick={handleTrocarFuncao}>
            {'Trocar função'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default connect(null, mapDispatchToProps)(TrocarFuncaoDrawer);
